import Toastify from 'toastify-js'
import("toastify-js/src/toastify.css")

export default {
    options: {
      // text: "Toast",
      duration: 5000,
      newWindow: true,
      close: false,
      // className: "info",
      gravity: "bottom", // `top` or `bottom`
      position: "center", // `left`, `center` or `right`
      stopOnFocus: true, // Prevents dismissing of toast on hover
      style: {
        background: "#37384e",
      },
      offset: {
          // x: 50, // horizontal axis - can be a number or a string indicating unity. eg: '2em'
          y: 65 // vertical axis - can be a number or a string indicating unity. eg: '2em'
        },
      onClick: function(){} // Callback after click
    }
    ,
    show(options = {}){
      Toastify({...this.options , ...options}).showToast()
    },
    success(options = {}){
      this.show({...options, ...{node: this.createObjectWithIcon('fas fa-check-circle', options.text)}})
    },
    warning(options = {}){
      this.show({...options, ...{node: this.createObjectWithIcon('fas fa-exclamation-circle', options.text)}})
    },
    setOptions(options){
      this.options = {...this.options, ...options}
    },
    createObjectWithIcon(icon_class, text){
      //criado container geral
      let container = document.createElement('div')
      
      //criando icon
      let icon = document.createElement('div')
      $(icon).addClass(icon_class + ' mr-3')
      
      //criando texto
      let inner_text = document.createElement('span')
      inner_text.innerHTML = text || "No text"

      //adicionando icon e text ao container
      container.appendChild(icon)
      container.appendChild(inner_text)

      return container
    }
}